import React from "react";
import { css } from "emotion";
import { colors, textSizes, boxStyles } from "../../styles/theme";
import { Link } from "react-router-dom";

const EditButton = () => {
  return (
    <Link to="/edit" className={container}>
      <p>Edit</p>
    </Link>
  );
};

export default EditButton;
const container = css`
  text-decoration: none;
  color: ${colors.brandColor};
  font-size: ${textSizes.normal};
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    font-size: ${textSizes.intermediate};
  }
`;
